import { render, staticRenderFns } from "./MobileValidation.vue?vue&type=template&id=6b70908c&scoped=true&"
import script from "./MobileValidation.vue?vue&type=script&lang=js&"
export * from "./MobileValidation.vue?vue&type=script&lang=js&"
import style0 from "./MobileValidation.vue?vue&type=style&index=0&id=6b70908c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b70908c",
  null
  
)

export default component.exports